export const LocalStorageKey = {
  isWalletConnected: "isWalletConnected",
};
